var map = {
	"./ArchivedEventsWidget.vue": "c885",
	"./BaseWidgetForm.vue": "306b",
	"./FacebookWidget.vue": "06a8",
	"./FaqWidget.vue": "f0f5",
	"./FestivalsWidget.vue": "312a",
	"./GalleryWidget.vue": "c474",
	"./HTMLWidget.vue": "7a59",
	"./HeaderWidget.vue": "8e42",
	"./ImageWidget.vue": "a62d",
	"./LogotypesWidget.vue": "45d3",
	"./NewsletterWidget.vue": "d8f8",
	"./PlaceDateWidget.vue": "90d8",
	"./RelatedEventsWidget.vue": "3386",
	"./SearchWidget.vue": "fdfb",
	"./SitePlanWidget.vue": "9b6e",
	"./SliderWidget.vue": "1d41",
	"./SubmenuWidget.vue": "3788",
	"./TextWidget.vue": "ce64",
	"./TicketsPriceWidget.vue": "d80f",
	"./TicketsWidget.vue": "b87b",
	"./TitleImageTextWidget.vue": "313c",
	"./TourWidget.vue": "3bb7",
	"./UpcomingEventsWidget.vue": "b08b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f7e1";